export const CvtIcon = {
  name: 'CvtIcon',
  props: {
    icon: {
      type: String,
      default: ''
    },
    hover: {
      type: Boolean,
      default: false
    },
    animation: {
      type: String,
      default: ''
    },
    prefixClass: {
      type: String,
      default: 'icon'
    }
  },
  computed: {
    iconName () {
        return this.icon.trim().toLowerCase()
    },
    iconAnimation () {
      return this.animation.trim().toLowerCase()
    },
    iconPrefix () {
      return (this.prefixClass || '').trim().toLowerCase()
    },
    iconClass () {
      if (this.iconName.indexOf('cvt-') === 0 || this.iconName.indexOf('keap-') === 0 || this.iconName.indexOf('fw-') === 0) {
        return this.iconName
      }
      return `fas fa-${this.iconName}`
    }
  },
  render: function (h) {
    return (
      <i
        class={[
          this.iconPrefix,
          this.iconClass,
          this.iconAnimation,
          this.hover ? 'hover' : ''
        ]}
        role='presentation'
      ></i>
    )
  }
}
